<template>
  <div>
    <div class="mb-6 mx-auto max-w-screen-xl px-4 sm:px-6" v-if="isAdmin">
      <div class="text-center">
        <h2
          class="text-4xl font-bebas tracking-wide leading-10 font-extrabold text-darkpurple mt-4"
        >
          Unapproved
        </h2>
      </div>
    </div>
    <div
      class="bg-vlight-paper shadow overflow-hidden sm:rounded-md"
      v-if="isAdmin"
    >
      <ul>
        <li
          v-for="(topic, idx) in unapproved"
          :key="idx"
          v-bind:class="{ 'border-t border-green': idx > 0 }"
        >
          <topic-approval-row :topic="topic"></topic-approval-row>
        </li>
      </ul>
    </div></div
></template>

<script>
import { topicsCollection } from "../utils/firebase";
import { mapGetters } from "vuex";
import TopicApprovalRow from "../components/TopicApprovalRow";

export default {
  name: "TopicApproval",
  data() {
    return {
      subscription: null,
      unapproved: []
    };
  },
  components: {
    TopicApprovalRow
  },
  created() {
    this.subscription = this.fetchUnapprovedTopics();
  },
  methods: {
    fetchUnapprovedTopics() {
      this.topics = [];
      const subscription = topicsCollection
        .where("approved", "==", false)
        .orderBy("timestamp", "desc")
        .onSnapshot(querySnapshot => {
          this.unapproved = [];
          querySnapshot.forEach(doc => {
            this.unapproved.push({ id: doc.id, ...doc.data() });
          });
        });
      return subscription;
    }
  },
  beforeDestroy() {
    if (this.subscription) {
      this.subscription();
    }
  },
  computed: {
    ...mapGetters(["loggedIn", "isAdmin"])
  }
};
</script>

<style scoped></style>
